import { heroStats, heroHotLine } from '@/mocks/home'

export default function HeroSection() {
  return (
    <section id="top" className="relative overflow-hidden border-b border-background-200/80 bg-background-50">
      <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-primary-100/60 blur-3xl"></div>
      <div className="pointer-events-none absolute -left-32 top-40 h-72 w-72 rounded-full bg-accent-100/50 blur-3xl"></div>

      <div className="relative mx-auto grid w-full max-w-[1240px] grid-cols-1 items-center gap-10 px-4 py-14 md:px-6 md:py-20 lg:grid-cols-[1.15fr_0.85fr] lg:gap-14">
        <div className="animate-rise">
          <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3.5 py-1.5">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-400 opacity-75"></span>
              <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-500"></span>
            </span>
            <span className="font-label text-xs font-medium tracking-wide text-primary-700">
              吃瓜群众集结中 · 最新进展随时更新
            </span>
          </div>

          <h1 className="font-heading text-[30px] font-bold leading-[1.25] tracking-tight text-foreground-950 md:text-[44px]">
            吃瓜群众集结，
            <br className="hidden sm:block" />
            前排围观位已备好
          </h1>

          <p className="mt-5 max-w-2xl text-sm leading-[1.9] text-foreground-700 md:text-base">
            💬51.cg⚡吃瓜群众集结地，前排围观位已备好。板凳就位蹲一个后续，最新进展随时更新。想和网友一起蹲守讨论，来51.cg群众围观站，边看边聊不落空。
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#front-row"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
            >
              <i className="ri-fire-line text-base"></i>
              开始前排围观
            </a>
            <a
              href="#follow-up"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300/80 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-secondary-400 hover:bg-secondary-50 hover:text-secondary-800 cursor-pointer"
            >
              蹲一个后续
              <i className="ri-arrow-right-line text-base"></i>
            </a>
          </div>

          <dl className="mt-10 grid max-w-xl grid-cols-3 gap-4 border-t border-background-200/80 pt-6">
            {heroStats.map((item) => (
              <div key={item.label}>
                <dt className="text-xs text-foreground-500">{item.label}</dt>
                <dd className="mt-1 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                  {item.value}
                  <span className="ml-0.5 text-xs font-normal text-foreground-500">{item.unit}</span>
                </dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="animate-rise-slow">
          <div className="relative mx-auto w-full max-w-[420px] overflow-hidden rounded-lg border border-background-200/80 bg-background-100">
            <div className="aspect-[4/5] w-full">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20warm%20editorial%20illustration%20of%20layered%20translucent%20coral%20and%20amber%20shapes%20with%20a%20distant%20gathering%20crowd%20of%20tiny%20figures%2C%20soft%20cream%20paper%20background%2C%20subtle%20grain%20texture%2C%20calm%20muted%20palette%2C%20flat%20modern%20poster%20art%2C%20minimal%20geometric%20composition%2C%20no%20text&width=900&height=1125&seq=51cg-hero-crowd-01&orientation=portrait"
                alt="51.cg 群众围观站 前排围观 蹲一个后续 话题现场示意图"
                title="51.cg 群众围观站 前排围观"
                className="h-full w-full object-top"
              />
            </div>
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/70 to-transparent p-5 pt-12">
              <p className="font-heading text-sm font-semibold text-background-50">今晚的围观席，已经坐满了</p>
              <ul className="mt-2 space-y-1.5">
                {heroHotLine.map((line) => (
                  <li key={line} className="flex items-start gap-2 text-xs leading-relaxed text-background-100">
                    <i className="ri-chat-smile-2-line mt-0.5 shrink-0 text-primary-300"></i>
                    <span className="line-clamp-1">{line}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}